import apiClient from "./api";
import {
  ValidationRun,
  ValidationDashboardResponse,
} from "@app-types/tap-partner-vault";

const DASHBOARD_ENDPOINT = "/api/validation-dashboard";
const RUNS_ENDPOINT = "/api/validation-runs";

export const validationRunsService = {
  async getDashboard(): Promise<ValidationDashboardResponse> {
    const response = await apiClient.get<ValidationDashboardResponse>(DASHBOARD_ENDPOINT);
    return response.data;
  },

  async listRuns(credentialId?: string): Promise<ValidationRun[]> {
    const params = credentialId ? `?credential_id=${credentialId}` : "";
    const response = await apiClient.get<{ runs: ValidationRun[] }>(
      `${RUNS_ENDPOINT}${params}`
    );
    return response.data.runs;
  },

  async getRun(runId: string): Promise<ValidationRun> {
    const response = await apiClient.get<ValidationRun>(
      `${RUNS_ENDPOINT}/${runId}`
    );
    return response.data;
  },

  async startRun(credentialId: string): Promise<ValidationRun> {
    const response = await apiClient.post<ValidationRun>(RUNS_ENDPOINT, {
      credential_id: credentialId,
    });
    return response.data;
  },

  async getScreenshot(runId: string, index: number): Promise<string> {
    const response = await apiClient.get(
      `${RUNS_ENDPOINT}/${runId}/screenshots/${index}`,
      { responseType: "arraybuffer" }
    );
    const blob = new Blob([response.data], { type: "image/png" });
    return URL.createObjectURL(blob);
  },

  async getLog(runId: string): Promise<string> {
    const response = await apiClient.get<string>(
      `${RUNS_ENDPOINT}/${runId}/log`,
      { responseType: "text" }
    );
    return response.data;
  },
};
